import { Mic, MicOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { getIconSizeClass, type ButtonSize } from '../utils';

interface MuteButtonProps {
  isAudioOn: boolean;
  onToggle: () => void;
  size?: ButtonSize;
  className?: string;
}

export function MuteButton({
  isAudioOn,
  onToggle,
  size = 'default',
  className,
}: MuteButtonProps) {
  const { t } = useTranslation();
  const iconSize = getIconSizeClass(size);

  const muteLabel = t('videoSession.actions.muteMicrophone', 'Mute microphone');
  const unmuteLabel = t('videoSession.actions.unmuteMicrophone', 'Unmute microphone');
  const label = isAudioOn ? muteLabel : unmuteLabel;

  return (
    <Button
      variant={isAudioOn ? 'outline' : 'destructive'}
      size={size === 'sm' ? 'icon-sm' : size === 'lg' ? 'icon-lg' : 'icon'}
      onClick={onToggle}
      className={cn('min-h-[44px] min-w-[44px]', className)}
      title={label}
      aria-label={label}
      aria-pressed={!isAudioOn}
    >
      {isAudioOn ? (
        <Mic className={iconSize} aria-hidden="true" />
      ) : (
        <MicOff className={iconSize} aria-hidden="true" />
      )}
    </Button>
  );
}
